module.exports = __webpack_public_path__ + "static/el-cerro-de-la-silla-b9578d0d71c2d622f3c3e1f35c11a806.jpg";